import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isIosSwipeBackGestureActive } from '@/utils/iosSwipeBack';

export const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (isIosSwipeBackGestureActive()) {
      return;
    }

    // 1. Scroll window and body to top
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    // 2. Scroll any main or overflow container elements to top
    const scrollContainers = document.querySelectorAll('main, .overflow-auto, .overflow-y-auto');
    scrollContainers.forEach((container) => {
      container.scrollTop = 0;
    });
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
